module.exports = __webpack_public_path__ + "img/no-admins.ba8ee667.png";